import { Dialog, Transition } from "@headlessui/react"
import { Fragment, useRef, useState } from "react"
import { AiOutlineCloseCircle } from "react-icons/ai"
//import MathJax from "react-mathjax"
import { toPng } from "html-to-image"

export default function AddEquation({
  isOpen,
  setIsOpen,
  setAnswerBody,
  index,
  multi,
  simple
}) {
  const [formula, setFormula] = useState("")
  const [preview, setPreview] = useState("")

  const equationRef = useRef(null)

  const handleConvertToImage = () => {
    toPng(equationRef.current).then(dataUrl => {
      if (multi) {
        return setAnswerBody(prev => {
          const body = prev[index].body
          return [
            ...prev.slice(0, index),
            {
              id: prev[index].id,
              title: prev[index].title,
              body: body + `<img src="${dataUrl}" alt="equation" />`
            },
            ...prev.slice(index + 1)
          ]
        })
      } else if (simple) {
        setAnswerBody(prev => {
          return prev + `<img src="${dataUrl}" alt="equation" />`
        })
      } else {
        setAnswerBody(prev => {
          const body = prev[0].body
          return [
            {
              id: prev[0].id,
              title: prev[0].title,
              body: body + `<img src="${dataUrl}" alt="equation" />`
            }
          ]
        })
      }
    })
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-[320px] transform rounded-2xl bg-white py-10 shadow-xl transition-all sm:w-[485px]">
                <div
                  className="absolute right-0 top-0 cursor-pointer p-4 text-neutral-1"
                  onClick={() => setIsOpen(false)}
                >
                  <AiOutlineCloseCircle size={28} />
                </div>
                <div className="ml-auto mr-2 w-11/12 pr-4 sm:mr-4 sm:w-10/12 sm:pr-16">
                  <h5 className="text-heading-4 font-medium text-neutral-1">
                    Insert Equation
                  </h5>

                  <textarea
                    // type="text"
                    rows={5}
                    className="mt-4 w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-primary"
                    placeholder="Enter Equation"
                    value={formula}
                    onChange={e => {
                      if (preview) {
                        setPreview("")
                      } else {
                        setFormula(e.target.value)
                      }
                    }}
                  />

                  {/* <MathJax.Provider>
                    <div ref={equationRef}>
                      <MathJax.Node formula={preview} />
                    </div>
                  </MathJax.Provider> */}

                  <button
                    disabled={!formula}
                    onClick={() => {
                      if (!preview) {
                        return setPreview(formula)
                      } else {
                        handleConvertToImage()
                        setIsOpen(false)
                        setFormula("")
                      }
                    }}
                    className={`m-2 rounded-md bg-primary px-4 py-2 text-white ${
                      !formula && "cursor-not-allowed opacity-50"
                    }`}
                  >
                    {!preview ? "Preview" : "Add Equation"}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
